export default "__VITE_ASSET__a3970150__"